

import React from 'react'
import "./Loader.css"
export default function Loader() {
  return (
    <div className='loading ' id='#container'>
        <div></div>
    </div>
  )
}
